export const state = () => ({
    selectPrincipal: {},
    Result:'',
    editPrincipal:{},

companyPrincipals: [],
countPrincipals : 0
})